import useUiPreferenceCache, {
  MeetingsViewEnum,
} from "@apps/use-ui-preference-cache/use-ui-preference-cache";
import useDocumentTitle from "@components/use-document-title/use-document-title";

import MeetingsLayout from "./layout";

const MeetingsPage = ({ view }: { view?: MeetingsViewEnum }) => {
  const { uiPreferenceCache } = useUiPreferenceCache();
  const materializedView = view ?? uiPreferenceCache.meetingsView;
  useDocumentTitle(
    materializedView === MeetingsViewEnum.calendar ? "Calendar" : "Meetings",
  );

  // RENDER
  return <MeetingsLayout />;
};

export default MeetingsPage;
